import { SearchOffers } from '@lambda/commons/apis/elasticsearch/types';
import cn from 'classnames';
import Image from 'next/future/image';
import Link from 'next/link';
import { calculateSavings, getOfferUri } from '@/lib/offer';
import { priceFormater } from '@/settings/index';
import { streamLineCondition } from '@/lib/collections/helpers';

const Savings = ({
  price,
  comparePrice,
}: {
  price: number;
  comparePrice?: number | null;
}) => {
  if (!comparePrice) return null;
  const percentageSaving = calculateSavings(price, comparePrice);

  if (percentageSaving > 3) {
    return (
      <div className="mb-2 ml-2 flex items-center justify-center rounded-full bg-red px-2 py-0.5 text-[11px] text-white xs:mb-0 xs:ml-1 sm:ml-0">
        Save <span className="ml-1 font-semibold">{percentageSaving}%</span>
      </div>
    );
  }

  return null;
};

const OfferCard = ({
  offer,
  conditionOptions,
}: {
  offer: SearchOffers;
  conditionOptions: string[];
}) => {
  const { comparePrice, price, images, title } = offer;
  const savingsPercentage = calculateSavings(price, comparePrice);
  const shouldShowComparePrice =
    comparePrice && comparePrice > price && savingsPercentage > 3;

  const streamlinedTitle = streamLineCondition(title, conditionOptions);

  return (
    <Link href={getOfferUri(offer)} passHref key={offer.sku}>
      <a
        className={cn(
          'relative rounded-md border bg-white p-2 text-sm 3xs:p-3 sm:p-4',
        )}
      >
        <div className="flex h-full flex-col gap-3">
          <div className="flex-1 px-3">
            <div className="relative h-full min-h-[100px] w-full">
              <Image
                src={images?.[0] ?? offer.imageSrc ?? ''}
                alt={streamlinedTitle}
                className="h-full w-full object-contain"
                fill
              />
            </div>
          </div>
          <div className="flex flex-1 items-center justify-center">
            <div>
              <h3
                // eslint-disable-next-line tailwindcss/no-custom-classname
                className="three-line-ellipsis text-sm"
              >
                {streamlinedTitle.replace(/Oppo/g, 'OPPO')}
              </h3>

              <div className="mt-3 flex items-center justify-between">
                <div className="flex flex-col justify-center ">
                  <h3 className="text-sm font-semibold">
                    {priceFormater.long(price)}
                  </h3>
                  {shouldShowComparePrice && comparePrice && (
                    <h4 className="text-xs text-slate-gray-300 line-through">
                      {priceFormater.long(comparePrice)}
                    </h4>
                  )}
                </div>
                {shouldShowComparePrice && (
                  <div>
                    <Savings price={price} comparePrice={comparePrice} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </a>
    </Link>
  );
};

export default OfferCard;
